<p-dialog
  [baseZIndex]="2000"
  [breakpoints]="{'1200px': '88vw', '768px': '95vw'}"
  [(visible)]="modal"
  [closable]="false"
  [closeOnEscape]="false"
  [dismissableMask]="false"
  [modal]="true"
  [position]="'center'"
  [showHeader]="false"
  [draggable]="false"
  [style]="{ width: '820px', maxWidth: '95vw' }"
>
  <fieldset [disabled]="processing">
    <div class="quick-patient-modal">
      <div class="quick-patient-modal__header">
        <div>
          <h3 class="text-primary bold mb-1">
            {{ showCreateForm ? 'Create Patient' : modalTitle }}
          </h3>
          <small class="text-muted" *ngIf="!showCreateForm">
            Search only within the current doctor's patient list.
          </small>
          <small class="text-muted" *ngIf="showCreateForm">
            {{ createFormDescription }}
          </small>
          <div class="quick-patient-modal__context-chip" *ngIf="isServiceFlow && selectedTemplate?.name">
            <i class="fas fa-file-alt mr-2"></i>
            {{ selectedTemplate?.name }}
          </div>
        </div>

        <button type="button" class="btn btn-link quick-patient-modal__close" (click)="onClose()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="quick-patient-modal__content" *ngIf="!showCreateForm">
        <div class="form-group mb-3">
          <small class="text-muted">Search Patient</small>
        </div>

        <form [formGroup]="searchForm" (ngSubmit)="search()">
          <div class="form-row align-items-end">
            <div class="col-12 col-md-5 mb-3">
              <label for="quick-patient-first-name">First Name</label>
              <input
                id="quick-patient-first-name"
                type="text"
                class="form-control"
                formControlName="firstName"
                placeholder="Enter first name"
              />
            </div>

            <div class="col-12 col-md-5 mb-3">
              <label for="quick-patient-last-name">Last Name</label>
              <input
                id="quick-patient-last-name"
                type="text"
                class="form-control"
                formControlName="lastName"
                placeholder="Enter last name"
              />
            </div>

            <div class="col-12 col-md-2 mb-3">
              <button type="submit" class="btn btn-primary btn-block" [disabled]="!canSearch || searching">
                <span *ngIf="!searching">Search</span>
                <span *ngIf="searching">
                  <i class="fas fa-circle-notch spinning mr-2"></i>
                  Search
                </span>
              </button>
            </div>
          </div>
        </form>

        <div class="quick-patient-modal__hint" *ngIf="searchSubmitted && !canSearch">
          Enter at least a first name or a last name.
        </div>

        <div class="quick-patient-modal__results" *ngIf="searchSubmitted && canSearch">
          <div class="quick-patient-modal__results-header">
            <div>
              <h5>Search Results</h5>
              <small class="text-muted">{{ searchResults?.total || 0 }} patient match{{ (searchResults?.total || 0) === 1 ? '' : 'es' }}</small>
            </div>

            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="clearSearch()">
              Clear
            </button>
          </div>

          <div class="quick-patient-modal__results-scroll">
            <div class="quick-patient-modal__results-state" *ngIf="searching">
              <i class="fas fa-circle-notch spinning mr-2"></i>
              Looking up patients...
            </div>

            <div class="quick-patient-modal__results-list" *ngIf="!searching && searchResults?.data?.length">
              <div
                class="quick-patient-modal__result-card"
                *ngFor="let patient of searchResults?.data | paginate : {
                  id: 'quick_patient_results',
                  itemsPerPage: searchResults?.per_page,
                  currentPage: searchResults?.current_page,
                  totalItems: searchResults?.total
                }"
              >
                <div class="quick-patient-modal__result-copy">
                  <h6>{{ patient?.display }}</h6>
                  <div class="quick-patient-modal__result-meta">
                    <span>{{ patient?.age_sex_complete || patient?.age_sex }}</span>
                    <span>{{ patient?.date_of_birth_string }}</span>
                    <span>{{ patient?.patient_id }}</span>
                  </div>
                </div>

                <button type="button" class="btn btn-primary btn-sm" [disabled]="processing" (click)="selectPatient(patient)">
                  <span *ngIf="!processing">Select</span>
                  <span *ngIf="processing">
                    <i class="fas fa-circle-notch spinning mr-2"></i>
                    Working
                  </span>
                </button>
              </div>
            </div>

            <div
              class="quick-patient-modal__results-state quick-patient-modal__results-state--empty"
              *ngIf="!searching && !searchResults?.data?.length"
            >
              No matching patient found.
            </div>
          </div>

          <div class="quick-patient-modal__pagination" *ngIf="searchResults?.total > perPage">
            <pagination-controls (pageChange)="search($event)" id="quick_patient_results"></pagination-controls>
          </div>
        </div>
      </div>

      <div class="quick-patient-modal__content" *ngIf="showCreateForm">
        <form [formGroup]="patientForm" (ngSubmit)="savePatient()">
          <div class="form-row">
            <div class="col-12 col-md-2 mb-3">
              <label for="quick-patient-prefix">Prefix/Title</label>
              <select id="quick-patient-prefix" class="form-control" formControlName="prefix">
                <option [ngValue]="null">Select</option>
                <option value="Mr.">Mr.</option>
                <option value="Ms.">Ms.</option>
                <option value="Mrs.">Mrs.</option>
                <option value="Dr.">Dr.</option>
                <option value="Atty.">Atty.</option>
                <option value="Engr.">Engr.</option>
              </select>
            </div>

            <div class="col-12 col-md-3 mb-3">
              <label for="quick-patient-first">First Name <span class="text-red">*</span></label>
              <input id="quick-patient-first" type="text" class="form-control" formControlName="firstName" />
              <small class="text-danger" *ngIf="patientControls.firstName.touched && patientControls.firstName.invalid">
                First name is required.
              </small>
            </div>

            <div class="col-12 col-md-3 mb-3">
              <label for="quick-patient-middle">Middle Name</label>
              <input id="quick-patient-middle" type="text" class="form-control" formControlName="middleName" />
            </div>

            <div class="col-12 col-md-4 mb-3">
              <label for="quick-patient-last">Last Name <span class="text-red">*</span></label>
              <input id="quick-patient-last" type="text" class="form-control" formControlName="lastName" />
              <small class="text-danger" *ngIf="patientControls.lastName.touched && patientControls.lastName.invalid">
                Last name is required.
              </small>
            </div>
          </div>

          <div class="form-row">
            <div class="col-12 col-md-2 mb-3">
              <label for="quick-patient-suffix">Suffix</label>
              <input id="quick-patient-suffix" type="text" class="form-control" formControlName="suffix" />
            </div>

            <div class="col-12 col-md-3 mb-3">
              <label for="quick-patient-nickname">Nickname</label>
              <input id="quick-patient-nickname" type="text" class="form-control" formControlName="nickName" />
            </div>

            <div class="col-12 col-md-3 mb-3">
              <label for="quick-patient-sex">Sex <span class="text-red">*</span></label>
              <select id="quick-patient-sex" class="form-control" formControlName="sex">
                <option [ngValue]="null">Select</option>
                <option *ngFor="let option of sexOptions" [value]="option.value">
                  {{ option.display }}
                </option>
              </select>
              <small class="text-danger" *ngIf="patientControls.sex.touched && patientControls.sex.invalid">
                Sex is required.
              </small>
            </div>

            <div class="col-12 col-md-3 mb-3">
              <label for="quick-patient-dob">Date of Birth <span class="text-red">*</span></label>
              <input
                id="quick-patient-dob"
                type="date"
                class="form-control"
                formControlName="dateOfBirth"
                max="9999-12-31"
                (change)="updateAge()"
              />
              <small class="text-danger" *ngIf="patientControls.dateOfBirth.touched && patientControls.dateOfBirth.errors?.required">
                Date of birth is required.
              </small>
              <small class="text-danger" *ngIf="patientControls.dateOfBirth.touched && patientControls.dateOfBirth.errors?.invalidDate">
                Date of birth cannot be in the future.
              </small>
            </div>

            <div class="col-12 col-md-1 mb-3">
              <label for="quick-patient-age">Age</label>
              <input id="quick-patient-age" type="text" class="form-control" formControlName="age" readonly />
            </div>
          </div>

          <div class="form-row">
            <div class="col-12 col-md-6 mb-3">
              <label for="quick-patient-email">Contact Details Email Address</label>
              <input id="quick-patient-email" type="email" class="form-control" formControlName="emailAddress" />
              <small class="text-danger" *ngIf="patientControls.emailAddress.touched && patientControls.emailAddress.errors?.email">
                Enter a valid email address.
              </small>
            </div>

            <div class="col-12 col-md-6 mb-3">
              <label for="quick-patient-mobile">Contact Details Mobile Number</label>
              <input
                id="quick-patient-mobile"
                type="text"
                class="form-control"
                formControlName="mobileNumber"
                placeholder="09XXXXXXXXX or 9XXXXXXXXX"
              />
              <small class="text-danger" *ngIf="patientControls.mobileNumber.touched && patientControls.mobileNumber.errors?.invalidMobile">
                Enter a valid Philippine mobile number.
              </small>
            </div>
          </div>
        </form>
      </div>
    </div>
  </fieldset>

  <p-footer>
    <div class="quick-patient-modal__footer" *ngIf="!showCreateForm">
      <div class="quick-patient-modal__callout">
        <div class="quick-patient-modal__callout-copy">
          <h6>Can’t find the right patient?</h6>
          <p>{{ calloutDescription }}</p>
        </div>

        <div class="quick-patient-modal__footer-actions">
          <button type="button" class="btn btn-outline-primary btn-sm" (click)="openCreateForm()">
            Create New Patient
          </button>
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="onClose()" [disabled]="processing">
            Close
          </button>
        </div>
      </div>
    </div>

    <div class="quick-patient-modal__footer quick-patient-modal__footer--form" *ngIf="showCreateForm">
      <div class="quick-patient-modal__footnote">
        Optional contact details can be completed later in the patient profile.
      </div>

      <div class="quick-patient-modal__footer-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="backToSearch()" [disabled]="processing">
          Back
        </button>
        <button type="button" class="btn btn-primary" (click)="savePatient()" [disabled]="processing">
          <span *ngIf="!processing">Save and Continue</span>
          <span *ngIf="processing">
            <i class="fas fa-circle-notch spinning mr-2"></i>
            Saving
          </span>
        </button>
      </div>
    </div>
  </p-footer>
</p-dialog>

<p-dialog
  [baseZIndex]="2100"
  [breakpoints]="{'768px': '92vw'}"
  [(visible)]="confirmationVisible"
  [closable]="false"
  [closeOnEscape]="false"
  [dismissableMask]="false"
  [modal]="true"
  [draggable]="false"
  [style]="{ width: '480px', maxWidth: '92vw' }"
>
  <div class="quick-patient-confirmation">
    <div class="quick-patient-confirmation__icon">
      <i class="fas fa-user-check"></i>
    </div>

    <h4>Confirm Selected Patient</h4>
    <p>Please confirm that this is the correct patient before continuing.</p>

    <div class="quick-patient-confirmation__card" *ngIf="pendingSelectedPatient">
      <h5>{{ pendingSelectedPatient?.display }}</h5>
      <div class="quick-patient-confirmation__meta">
        <span>{{ pendingSelectedPatient?.age_sex_complete || pendingSelectedPatient?.age_sex }}</span>
        <span>{{ pendingSelectedPatient?.date_of_birth_string }}</span>
        <span>{{ pendingSelectedPatient?.patient_id }}</span>
      </div>
    </div>
  </div>

  <p-footer>
    <div class="quick-patient-confirmation__actions">
      <button type="button" class="btn btn-outline-secondary" (click)="cancelSelectedPatient()" [disabled]="processing">
        Cancel
      </button>
      <button type="button" class="btn btn-primary" (click)="confirmSelectedPatient()" [disabled]="processing">
        <span *ngIf="!processing">Yes, Continue</span>
        <span *ngIf="processing">
          <i class="fas fa-circle-notch spinning mr-2"></i>
          Working
        </span>
      </button>
    </div>
  </p-footer>
</p-dialog>
